<script setup lang="ts">
import type { Link } from 'types';

const props = defineProps<{
  link: Link;
  hasUnderline?: boolean;
}>();

const linkIsExternal = computed(() => {
  return props.link.linkType === 'External';
});
</script>

<template>
  <BaseLink
    :to="linkIsExternal ? link.url : handleRelativeUrl(link.url)"
    :target="linkIsExternal ? '_blank' : link.target"
    :rel="linkIsExternal ? 'noopener noreferrer' : ''"
    :has-underline="hasUnderline"
  >
    {{ link.name }}
  </BaseLink>
</template>
